import React from 'react';
import { Box, Typography } from '@mui/material';
import { MQ } from './teacherTokens';

/**
 * `.phead` — page title, muted subtitle, and an optional right-aligned action
 * that wraps beneath the title on narrow screens (the mockup applies this
 * inline on Quick Tests / Chat / Reports).
 *
 * `variant="welcome"` renders the dashboard's `.welcome` block instead, which
 * is the same shape at a slightly smaller title size.
 */
const TeacherPageHeader = ({ title, subtitle, action, variant = 'page', children, sx = {} }) => {
  const isWelcome = variant === 'welcome';

  return (
    <Box
      sx={{
        mb: isWelcome ? '24px' : '22px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: '12px',
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          sx={{
            fontSize: isWelcome ? '24px' : '26px',
            fontWeight: 700,
            letterSpacing: '-.01em',
            lineHeight: 1.2,
            color: 'text.primary',
            [MQ.phone]: { fontSize: isWelcome ? '21px' : '22px' },
            [MQ.phoneSm]: { fontSize: '20px' },
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              color: 'text.secondary',
              mt: '5px',
              fontSize: '14px',
              fontWeight: isWelcome ? 500 : 400,
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }}
          >
            {subtitle}
          </Typography>
        )}
        {children}
      </Box>
      {action}
    </Box>
  );
};

export default TeacherPageHeader;
